import OptimizationSection from './OptimizationSection';

export default OptimizationSection;
